import { syncProgram } from 'actions/program';

function programChanged({ dispatch }, { program, notifyingDirector }) {
  dispatch(syncProgram({ program, notifyingDirector }));
}

export default programChanged;
